import customAxios from '../../../utils/customAxios';
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleCheck,
  faCircleChevronLeft,
} from '@fortawesome/free-solid-svg-icons';
import '../../../scss/Components/_modal.scss';
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { toast } from 'react-toastify';
import { GlobalVariables } from '../../../globalVar';
import { getToast } from '../../../utils/toastConfig';

function ModalSActivate(props) {
  const {
    siteModalActivateString = '¿Deseas activar esta sucursal?',
    siteMDSiteNameString,
    siteMDClientString,
    siteMDStreetNameString,
    siteMDAddressNumString,
    siteMDPCString,
    siteMDEDateString,
    modalYesString,
    modalNoString,
  } = useTranslationHook();

  const activateSiteId = localStorage.getItem('siteIdToActivate');
  const activateSiteName = localStorage.getItem('siteNameToActivate');
  const activateSiteAddressStreet = localStorage.getItem(
    'siteAddressStreetToActivate'
  );
  const activateSiteAddressNum = localStorage.getItem(
    'siteAddressNumToActivate'
  );
  const activateSiteAddressPC = localStorage.getItem('siteAddressPCToActivate');
  const activateSiteBusiness = localStorage.getItem('siteBusinessToActivate');
  const activateSiteCreatedDate = localStorage.getItem(
    'siteCreatedDateToActivate'
  );

  const activateSite = () => {
    customAxios
      .patch(
        `${GlobalVariables.getURL()}updateSiteStatusActive/${activateSiteId}`,
        {},
        {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('token'),
          },
        }
      )
      .then((response) => {
        hideS();
      })
      .catch((error) => {
        console.error(error);
        getToast({
          status: 'error',
          title: 'Error al activar sucursal. Vuelve a intentarlo.',
        });
      });
  };

  const hideS = () => {
    props.onHide();
    getToast({ status: 'success', title: 'Sucursal activada exitosamente.' });

    let endpoint = `${GlobalVariables.getURL()}listClientSites`;
    if (props.selectedClients.length > 0) {
      endpoint += `?id=${props.selectedClients}`;
    }
    props.getSites(endpoint);
  };

  const hideN = () => {
    props.onHide();
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      backdropClassName="modal-backdrop"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title className="modal-title" id="contained-modal-title-vcenter">
          {siteModalActivateString}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <span className="delete-info">
          <strong>{siteMDSiteNameString}:</strong> {activateSiteName}
        </span>
        <br />
        <span className="delete-info">
          <strong>{siteMDClientString}:</strong> {activateSiteBusiness}
        </span>
        <br />
        <span className="delete-info">
          <strong>{siteMDStreetNameString}:</strong> {activateSiteAddressStreet}
        </span>
        <br />
        <span className="delete-info">
          <strong>{siteMDAddressNumString}:</strong> {activateSiteAddressNum}
        </span>
        <br />
        <span className="delete-info">
          <strong>{siteMDPCString}:</strong> {activateSiteAddressPC}
        </span>
        <br />
        <span className="delete-info">
          <strong>{siteMDEDateString}:</strong> {activateSiteCreatedDate}
        </span>
      </Modal.Body>
      <Modal.Footer>
        <button className="modal-button" onClick={activateSite}>
          <FontAwesomeIcon icon={faCircleCheck} /> Si, quiero activar este sitio
        </button>
        <button className="modal-button no" onClick={hideN}>
          <FontAwesomeIcon icon={faCircleChevronLeft} /> {modalNoString}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalSActivate;
